import { render, staticRenderFns } from "./OurCourses.vue?vue&type=template&id=69338946&scoped=true&"
import script from "./OurCourses.vue?vue&type=script&lang=js&"
export * from "./OurCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69338946",
  null
  
)

export default component.exports